import React, { useEffect, useState } from "react";
import BaseComponent from "../baseComponent";
import { AddState, GetState, GetAllCountryDetails, GetCity, AddCityDetails, GetStatebyID, UpdateCityDetails, getCityById } from "../../Apis/countryApi";
import Modal from "react-bootstrap/Modal";
import "./cityMaster.css";
import DataTable from "react-data-table-component";
import TableComponent from "../../Common/TableComponent/tableComponent";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Puff } from "react-loader-spinner";
import { TableLoader } from "../../Common/ShimmerLoader";
import { useNavigate } from "react-router-dom";
import useIdle from "../../../Hooks/useidle";

function CityMaster() {
  const [lgShow, setLgShow] = useState(false);
  const navigate = useNavigate();
  const [states, setStates] = useState([]);
  const [newStateName, setNewStateName] = useState("");
  // const [selectedCountry, setSelectedCountry] = useState("");
  const [countries, setCountries] = useState([]);
  // const [status, setStatus] = useState("")
  const [allcities, setAllCities] = useState([]);
  const [allStates, setAllStates] = useState([]);
  const [isOptionsLoading, setIsOptionsLoading] = useState(true);
  const [editCityId, setEditCityId] = useState(null);
  //const[selectedState,setSelectedState] = useState("");
  // const [newcityName,setNewCityName] =useState("");
  const [loadingCountries, setLoadingCountries] = useState(true);
  const [loadingStates, setLoadingStates] = useState(false);
  const headers = [
    "stateName",
    "cityName",
    "status",
    "actions",
  ];
  const [editCityData, setEditCityData] = useState("");
  const [formInput, setFormInput] = useState({
    // id:"",
    details: "",
    stateId: "",
    cityName: "",
   
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoadingCountries(true);
        const countriesData = await GetAllCountryDetails();
        setCountries(countriesData);
        setLoadingCountries(false);

        if (formInput.details) {
          setLoadingStates(true);
          const statesData = await GetStatebyID(formInput.details);
          setStates(statesData);
          setLoadingStates(false);
        } else {
          setStates([]);
        }
      } catch (error) {
        setLoadingCountries(false);
        setLoadingStates(false);
      }
    };

    fetchData();
  },
    [formInput.details]
  );


  const fetchCityData = async () => {
    try {
      const data = await GetCity();
      setAllCities(data);
      setIsOptionsLoading(false)
    } catch (error) {
    }
  };

  const fetchStateData = async () => {
    try {
      const data = await GetState();
      setAllStates(data);
      setIsOptionsLoading(false)
    } catch (error) {
    }
  };
  useEffect(() => {
    fetchCityData();
    fetchStateData()
  }, []
    // [lgShow]
  );



  const handleClose = () => {
    setLgShow(false);
    setFormInput({
      //id:"",
      details: "",
      stateId: "",
      cityName: "",
     
    });
    setEditCityData(null);
  };

  useEffect(() => {
    setFormInput(
      editCityData || {
        //  id: "",
        details: "",
        stateId: "",
        cityName: "",
       
      }
    );
  },
    [editCityData]
  );


  const handleCreateCity = async (e) => {
    e.preventDefault();
    try {
      setIsOptionsLoading(true);
      if (editCityData) {
        const updatedCityData = { ...formInput };
        const response = await UpdateCityDetails(updatedCityData);
        setAllCities([...allcities, response]);
        // toast.success("Circles updated successfully");
        toast.success('city updated Successfully!', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        })
        // Update the state with the modified data
        fetchCityData();
        handleClose();
      } else {
        const response = await AddCityDetails(formInput);
        setAllCities([...allcities, response]);
        // toast.success("Circles added successfully");
        toast.success('City added Successfully!', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        })
      }
      fetchCityData();
      handleClose(); // Close the modal after success
    }
    catch (error) {
      if (error.response.status === 422) {
        Object.values(error.response.data.errors).map((item) => {
          toast.error(item[0], {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        });
      } else {
        toast.error(error.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } finally {
      setIsOptionsLoading(false)
    }
    //handleClose();
  };

  const handleEditCity = async (selectedCity) => {
    setEditCityData(selectedCity);
    setEditCityId(selectedCity.id);
    const { stateId, details } = selectedCity;
    setLgShow(true);
    setFormInput({
      ...formInput,
      details,
      stateId,
      cityName: selectedCity.cityName,
      status: selectedCity.status,
    });
    setLgShow(true);
    setIsOptionsLoading(true)
    setTimeout(() => {
      setIsOptionsLoading(false);
    }, 1000);
    try {
      const stateData = await GetStatebyID(details);
      setStates(stateData.data);
    } catch (error) {
    }
  };

  // useEffect(() => {
  //   if (editCityData) {
  //     setFormInput({
  //       id: editCityData.id,
  //       details: editCityData.details,
  //       stateId: editCityData.stateId,
  //       cityName: editCityData.cityName || "",
  //       status: editCityData.status,
  //     });
  //   } else {
  //     // Reset form fields when not in edit mode
  //     setFormInput({
  //       id: "",
  //       details: "",
  //       stateId: "",
  //       cityName: "",
  //      
  //     });
  //   }
  // },[]
  //  //[editCityData]
  //  );

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormInput((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleShow = () => {
    setLgShow(true);
    setIsOptionsLoading(true)
    setTimeout(() => {
      setIsOptionsLoading(false)
    }, 1000)
    setFormInput({
      id: "",
      details: "",
      stateId: "",
      cityName: "",
     
    });
    setEditCityData(null);
  };

  const handleViewCityData = async (id) => {
    try {
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setIsOptionsLoading(true);
      const response = await getCityById(id);
      const cityDetails = response.data;
      navigate("/city-details", { state: { cityDetails } });
    } catch (error) {
    } finally {
      setIsOptionsLoading(false);
    }
  };


  // const [showModal, setShowModal] = useState(false);
  // const [remainingTime, setRemainingTime] = useState(0);
  // const idleTime = 0.5;
  // const handleIdle = () => {
  //   setShowModal(true); //show modal
  //   setRemainingTime(idleTime * 60); //set 15 seconds as time remaining
  // };
  // const { isIdle } = useIdle({ onIdle: handleIdle, idleTime});
  // useEffect(() => {
  //   let interval;

  //   if (isIdle && showModal) {
  //     interval = setInterval(() => {
  //       setRemainingTime(
  //         (prevRemainingTime) =>
  //           prevRemainingTime > 0 ? prevRemainingTime - 1 : 0 //reduces the second by 1
  //       );
  //     }, 1000);
  //   }

  //   return () => {
  //     clearInterval(interval);
  //   };
  // }, [isIdle, showModal]);

  // useEffect(() => {
  //   if (remainingTime === 0 && showModal) {
  //     // alert("Time out!");
  //     setShowModal(false);
  //     navigate("/");
  //   }
  // }, [remainingTime, showModal, navigate]); // this is responsoble for logging user out after timer is down to zero and they have not clicked anything

  // const handleLogOut = () => {
  //   setShowModal(false);
  //   navigate("/");
  // };

  // const handleStayLoggedIn = () => {
  //   setShowModal(false);

  // };

  // function millisToMinutesAndSeconds(millis) {
  //   var minutes = Math.floor(millis / 60000);
  //   var seconds = ((millis % 60000) / 1000).toFixed(0);
  //   return minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
  // }

  return (
    <>
      {/* {showModal && (
        <Modal show={showModal} onHide={() => setShowModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Idle Timeout Warning</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>You are about to be logged out due to inactivity.</p>
            <p>Time remaining: {remainingTime} seconds</p>
          </Modal.Body>
          <Modal.Footer>
            <button onClick={handleStayLoggedIn}>Stay Logged In</button>
            <button onClick={handleLogOut}>Logout</button>
          </Modal.Footer>
        </Modal>
      )} */}
      {/* {isOptionsLoading && <TableLoader height={500} />} */}
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="top-header page-title">
              <span>City Details</span>
            </div>
            <div className="page-header">
              <div className="text-end mb-3">
                <button
                  className="button-container"
                  onClick={handleShow}
                >
                  <i className="fa-solid fa-plus me-1 icon-container"></i> Add City
                </button>
              </div>
              <div className="card">
                <div className="card-body">
                  <TableComponent isLoading={isOptionsLoading}
                    DataFetchURL={allcities}
                    headers={headers}
                    filterFunction={(data) =>
                      data.filter(
                        (item) => item.status === 1 || item.status === 2
                      )
                    }
                    editData={handleEditCity}
                    editCityData={editCityData}
                    viewData={(id) => handleViewCityData(id)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* {isOptionsLoading && <TableLoader height={500} />} */}
      <Modal
        size="lg"
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title id="example-modal-sizes-title-lg">
            {editCityData ? "Edit City" : "Add City"}
          </Modal.Title>
          <i class="fa-solid fa-xmark close-container" onClick={handleClose}></i>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleCreateCity}>
            <div className="row">
              {/* <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">Select Country Name <span style={{ color: '#EC1117' }}> *</span></label>
                  <select
                    className="form-select"
                    name="details"
                    value={formInput.details}
                    onChange={handleInputChange}
                  >
                    <option value="" disabled>
                      Select Country
                    </option>
                    {countries.map((country) => (
                      <option key={country.details} value={country.details}>
                        {country.countryName}
                      </option>
                    ))}
                  </select>
                </div>
              </div> */}
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">Select State Name <span style={{ color: '#EC1117' }}> *</span></label>
                  <select
                    className="form-select"
                    name="stateId"
                    value={formInput.stateId}
                    onChange={handleInputChange}
                  >
                    <option value="" disabled>
                      Select State
                    </option>
                    {loadingStates && <option>Loading states...</option>}
                    {Array.isArray(allStates) && !loadingStates.length > 0 ? (
                      allStates.map((state) => (
                        <option key={state.stateId} value={state.stateId}>
                          {state.stateName}
                        </option>
                      ))
                    ) : (
                      <option value="" disabled>
                        No states found
                      </option>
                    )}
                  </select>
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">Enter City Name <span style={{ color: '#EC1117' }}> *</span></label>
                  <input
                    type="text"
                    name="cityName"
                    className="form-control"
                    value={formInput.cityName}
                    //  onChange={(e) => setNewCityName(e.target.value)}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">Enter details <span style={{ color: '#EC1117' }}> *</span></label>
                  <input
                    type="text"
                    name="details"
                    className="form-control"
                    value={formInput.details}
                    //  onChange={(e) => setNewCityName(e.target.value)}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
            </div>

            <div className="modal-footer d-flex justify-content-center">
              <button
                type="submit"
                className="deployment-button"
              >
                <i class="fa-solid fa-check done-container"></i>
                {editCityData ? "Update City " : "Add City"}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default CityMaster;
